import { cn, Text } from '@youversion/design-system-components';
import { InfoCircleStroked } from '@youversion/design-system-icons';
import { Trans, useTranslation } from 'react-i18next';

import type { UploadKind } from '@/context/upload-state';

const HELPER_TEXT_KEYS: Record<UploadKind, string> = {
  sermon: 'upload_widget.failure_helper_text',
  video: 'upload_widget.failure_helper_text_video',
};

export interface UploadFailureMessageProps {
  className?: string;
  helperTextClassName?: string;
  /** Which authoring flow the failed upload came from; picks the wording. */
  kind?: UploadKind;
  showHelperText?: boolean;
  showIcon?: boolean;
  supportUrl: string;
}

export function UploadFailureMessage({
  className,
  helperTextClassName,
  kind = 'sermon',
  showHelperText = true,
  showIcon = true,
  supportUrl,
}: UploadFailureMessageProps) {
  const { t } = useTranslation('common');

  return (
    <div className={className}>
      <div className='flex items-center gap-0.5'>
        {showIcon ? (
          <InfoCircleStroked aria-hidden={true} className='shrink-0 text-alert-light dark:text-alert-dark' size='16' />
        ) : null}
        <Text className='text-[15px] font-medium leading-default' size='sm' variant='label'>
          {t('upload_widget.status_labels.failed')}
        </Text>
      </div>
      {showHelperText ? (
        <Text className={cn('mt-0.5', helperTextClassName)} size='xs' variant='paragraph'>
          <Trans
            components={{
              a: <a className='underline' href={supportUrl} rel='noopener noreferrer' target='_blank' />,
            }}
            i18nKey={HELPER_TEXT_KEYS[kind]}
            t={t}
          />
        </Text>
      ) : null}
    </div>
  );
}
